"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const query_1 = require("@reduxjs/toolkit/query");
const components_1 = require("components");
const merchant_management_v2_api_1 = require("merchant-management-v2-api");
const utils_1 = require("utils");
const TransactionStatusModal_1 = __importDefault(require("./TransactionStatusModal"));
function TransactionStatusModalShell({ transactionId, accountNumber, transactionStatus, expirationDate, isOpen, setIsOpen, }) {
    const { data, isError, isFetching } = (0, merchant_management_v2_api_1.useGetMerchantManagementV2TransactionsTransactionIdSigningProgressDetailsQuery)(isOpen
        ? {
            transactionId,
        }
        : query_1.skipToken);
    return ((0, jsx_runtime_1.jsx)(components_1.Modal, { isOpen: isOpen, setIsOpen: setIsOpen, contentClassName: "with-handle pad-0", children: !isFetching && !isError && data ? ((0, jsx_runtime_1.jsx)(TransactionStatusModal_1.default, { signingProgressDetails: data, accountNumber: accountNumber, transactionStatus: transactionStatus, expirationDate: expirationDate
                ? (0, utils_1.formatDateFromISOtoUSdateString)(expirationDate)
                : null })) : ((0, jsx_runtime_1.jsxs)("div", { className: "empty-modal", children: [' ', (0, jsx_runtime_1.jsx)(components_1.Spinner, {})] })) }));
}
exports.default = TransactionStatusModalShell;
